import { isNative } from "@/lib/appConfig";

// On native, open external http(s) links in the system browser (@capacitor/browser)
// instead of navigating away inside the app WebView (which traps the user with no
// browser chrome). Internal links (capacitor://localhost or same-origin) are left
// to React Router. No-op on web.
export function initExternalLinks() {
    if (!isNative()) return;
    document.addEventListener(
        "click",
        async (e) => {
            const a = e.target?.closest?.("a");
            if (!a) return;
            const url = a.href; // resolved absolute URL
            if (!/^https?:\/\//i.test(url)) return; // capacitor:// internal → ignore
            if (url === window.location.origin || url.startsWith(window.location.origin + "/")) return; // same-origin
            e.preventDefault();
            try {
                const { Browser } = await import("@capacitor/browser");
                await Browser.open({ url, presentationStyle: "popover" });
            } catch {
                window.open(url, "_blank");
            }
        },
        true,
    );
}
